module.exports = __webpack_public_path__ + "static/media/Judy Bayne.138674e1.png";